import type { PlatformRole } from "../../lib/types";
export type { PlatformRole } from "../../lib/types";

export type PlatformUser = {
  platform_user_id: string;
  user_id: string;
  name: string | null;
  mobile_number: string;
  email: string | null;
  status: "ACTIVE" | "DISABLED";
  user_status: "ACTIVE" | "BLOCKED" | "DISABLED";
  roles: PlatformRole[];
};

export type CreatePlatformUserRequest = {
  name: string;
  mobile_number: string;
  email?: string;
  role: PlatformRole;
};

export const platformRoleLabels: Record<PlatformRole, string> = {
  TECH_OPS: "Tech Ops",
  TECH_ADMIN: "Tech Admin"
};
